import { configureApi, type ApiClientConfig } from "@safers/api";
import { useAuthStore } from "./store";

/**
 * `configureApi`를 호출하면서 401 + refresh 실패 시 `useAuthStore.reset()`을 기본으로
 * 바인딩한다. 양쪽 앱이 동일한 콜백을 `main.tsx`에 중복 작성하지 않도록 하기 위한 헬퍼.
 *
 * 커스텀 `onUnauthorized`가 필요하면 명시적으로 넘겨 override 가능.
 */
export function configureAuthApi(config: ApiClientConfig) {
  const { onUnauthorized = () => useAuthStore.getState().reset(), ...rest } = config;
  configureApi({ ...rest, onUnauthorized });
}
